import React from 'react';
import Icon from '../../../components/AppIcon';
import { PHONEPE_UPI_OUTAGE_ALERT, PHONEPE_UPI_OUTAGE_BADGE } from '../../../constants/paymentCopy';

const PhonePeUPIOutageAlert = ({ className = '' }) => (
  <div
    role="alert"
    className={`relative overflow-hidden rounded-2xl border-2 border-dashed border-amber-400/90 bg-gradient-to-br from-amber-50 via-orange-50/90 to-amber-100/80 px-4 py-3 shadow-[0_4px_20px_-4px_rgba(245,158,11,0.45)] md:px-5 md:py-4 ${className}`}
  >
    <div
      className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full bg-amber-300/30 blur-2xl"
      aria-hidden
    />
    <div className="relative flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
      <div className="flex shrink-0 items-center gap-2">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-amber-400/90 text-amber-950 shadow-md ring-2 ring-amber-200/80 ring-offset-2 ring-offset-amber-50/90">
          <Icon name="Sparkles" size={22} color="currentColor" className="text-amber-950" />
        </span>
        <span className="rounded-full bg-amber-500/90 px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide text-white shadow-sm">
          {PHONEPE_UPI_OUTAGE_BADGE}
        </span>
      </div>
      <p className="text-left text-sm font-semibold leading-snug text-amber-950 md:text-base">
        {PHONEPE_UPI_OUTAGE_ALERT}
      </p>
    </div>
  </div>
);

export default PhonePeUPIOutageAlert;
